import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';
import {
  ConfirmDeleteOverlay,
  ConfirmDeleteBox,
  ConfirmDeleteHeader,
  ConfirmDeleteTitle,
  ConfirmDeleteCloseButton,
  ConfirmDeleteWarning,
  ConfirmDeleteLabel,
  ConfirmDeleteInput,
  ConfirmDeleteActions,
  ConfirmDeleteCancelButton,
  ConfirmDeleteSubmitButton,
} from './styled';

const CONFIRM_WORD = 'PROSSEGUIR';

interface ConfirmDeleteModalProps {
  isActioning: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ isActioning, onConfirm, onCancel }) => {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const canSubmit = inputValue === CONFIRM_WORD && !isActioning;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <ConfirmDeleteOverlay onClick={onCancel}>
      <ConfirmDeleteBox onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <ConfirmDeleteHeader>
          <ConfirmDeleteTitle>Deseja mesmo prosseguir?</ConfirmDeleteTitle>
          <ConfirmDeleteCloseButton onClick={onCancel} aria-label="Fechar">
            <XIcon />
          </ConfirmDeleteCloseButton>
        </ConfirmDeleteHeader>

        <ConfirmDeleteWarning>
          <span>⊘</span>
          <span>
            <strong>Atenção:</strong> Não será possível recuperar a atividade após exclusão.
          </span>
        </ConfirmDeleteWarning>

        <div>
          <ConfirmDeleteLabel htmlFor="confirm-delete-input">
            Digite <strong>"{CONFIRM_WORD}"</strong> para concluir a exclusão:
          </ConfirmDeleteLabel>
          <ConfirmDeleteInput
            id="confirm-delete-input"
            type="text"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            ref={inputRef}
            autoComplete="off"
          />
        </div>

        <ConfirmDeleteActions>
          <ConfirmDeleteCancelButton type="button" onClick={onCancel} disabled={isActioning}>
            Cancelar
          </ConfirmDeleteCancelButton>
          <ConfirmDeleteSubmitButton type="button" onClick={onConfirm} disabled={!canSubmit}>
            {isActioning ? 'Aguarde...' : 'Excluir'}
          </ConfirmDeleteSubmitButton>
        </ConfirmDeleteActions>
      </ConfirmDeleteBox>
    </ConfirmDeleteOverlay>
  );
};
